var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71094 28C1.60637 28 0.710937 28.8954 0.710937 30C0.710937 31.1046 1.60637 32 2.71094 32L26.7109 32C27.8155 32 28.7109 31.1046 28.7109 30C28.7109 28.8954 27.8155 28 26.7109 28L2.71094 28ZM16.7397 25.3339C15.5603 26.222 13.8616 26.222 12.6822 25.3339L1.88705 17.2051C-0.435173 15.4565 0.91206 12 3.91584 12L9.89911 12L11.4045 2.68886C11.9844 -0.897481 17.4321 -0.897477 18.012 2.68887L19.5174 12L25.506 12C28.5098 12 29.8571 15.4565 27.5348 17.2051L16.7397 25.3339Z",
    fill: "url(#paint0_linear_456_24064)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_456_24064",
    x1: 14.7109,
    y1: 32,
    x2: 14.7109,
    y2: -0.00089324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003E7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.b5afae74cb148e6108ce8d3dd53b4bb4.svg";
export { ForwardRef as ReactComponent };